export const fileStatuses = [
  {
    key: 'open',
    label: 'OPEN',
    color: 'primary'
  },
  // {
  //   key: 'processing',
  //   label: 'PROCESSING',
  //   color: 'warning'
  // },
  {
    key: 'failed',
    label: 'FAILED',
    color: 'red'
  },
  // {
  //   key: 'PAST DUE',
  //   label: 'PAST DUE',
  //   color: 'warning'
  // },
  {
    key: 'completed',
    label: 'COMPLETED',
    color: 'green-light'
  },
];
